module.exports = __webpack_public_path__ + "static/media/process-objective.549f4c08.svg";